export const APP_TOP_BAR_ROW_HEIGHT = 48
